export const START_LEVELS = "START_LEVELS";
export const LEVELS_SUCCESS = "LEVELS_SUCCESS";
export const LEVELS_FAIL = "LEVELS_FAIL";
